import React, { useState } from 'react'
import logo from '../assets/logo.svg';
import { Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import packageJson from '../../package.json';

const Logo = () => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Typography
                variant="h4"
                component="h3"
                gutterBottom
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 4,
                    direction: 'ltr',
                    fontSize: { xs: '1.5rem', sm: '2.125rem' },
                }}
            >
                <Box
                    component="span"
                    sx={{
                        background: 'linear-gradient(90deg, #7ea1ff 0%, #bfcde7 40%, #f6e27a 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        textFillColor: 'transparent',
                        fontWeight: 700,
                        letterSpacing: '0.04em',
                        textShadow: '0 2px 8px rgba(246, 226, 122, 0.15), 0 1px 2px rgba(126, 161, 255, 0.10)'
                    }}
                >
                    ASTROLOGYS
                </Box>
                <Typography
                    component="span"
                    sx={{
                        fontSize: { xs: '0.5em', sm: '0.7em' },
                        ml: '10px',
                        color: '#f6e27a',
                        fontWeight: 400,
                        letterSpacing: '0.04em',
                        textShadow: '0 1px 4px rgba(246, 226, 122, 0.18)'
                    }}
                >
                    AI
                </Typography>
                <Box
                    component="img"
                    src={logo}
                    alt="Astrologys AI"
                    sx={{
                        width: '90px',
                        ml: '10px',
                        maxWidth: { xs: '70px', sm: '90px' },
                        cursor: 'pointer',
                    }}
                    onClick={handleClickOpen}
                />
            </Typography>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="version-dialog-title"
                aria-describedby="version-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="version-dialog-title">
                ASTROLOGYS AI                
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" id="version-dialog-description">
                        גרסה: {packageJson.version}  
                    </Typography>
                    <Typography variant="body1" id="version-dialog-description">
                        תאריך: 03/05/2025  
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        סגור
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Logo

